goog.provide('yext.m4.confcode.adminconsole.routes');

goog.require('yext');

goog.scope(function() {
  var route = yext.m4.confcode.adminconsole.routes._route;

  yext.m4.confcode.adminconsole.routes.AdminConsole = {
    apply: route('/adminconsole/accounts/:businessId/resources'),
    checkBusinessAccess: route('/adminconsole/checkbusinessaccess'),
    diff: route('/adminconsole/diffresources'),
    completeSession: route('/adminconsole/completesession'),
    downloadResourcesFromBusiness: route('/adminconsole/downloadresources/:businessId'),
    downloadResources: route('/adminconsole/downloadresources'),
    validateVariable: route('/adminconsole/validatevariable'),
  };
});

/**
 * Helper method for routes, copied from js/yext/developerapps/routes.js.
 *
 * @param {string} path within apps with placeholders
 * @return {function(object): string} to be called with key/values
*/
yext.m4.confcode.adminconsole.routes._route = function(path) {
  return function(obj) {
    var pattern = path;
    obj = obj || {};
    var queryParams = [];
    for (var key in obj) {
      var vals = obj[key];
      if (!Array.isArray(obj[key])) {
        vals = [obj[key]];
      }
      for (var i = 0; i < vals.length; i++) {
        var val = encodeURIComponent(vals[i]);
        var pattern2 = pattern.replace(':'+key, val);
        if (pattern == pattern2) {
          queryParams.push(key + '=' + val);
        }
        pattern = pattern2;
      }
    }
    if (queryParams.length > 0) {
      pattern += '?' + queryParams.join('&');
    }
    return pattern;
  };
};
